import React from "react";

export default function TermsOfServiceEs() {
  return (
    <>
      <h1>TÉRMINOS DE SERVICIO DE LIGAVIRTUALF1</h1>
      <p>
        <strong>Última actualización:</strong> Junio de 2026
      </p>

      <p>
        Bienvenido/a a <strong>LigaVirtualF1</strong> (en adelante, "la
        Comunidad", "nosotros" o "la Plataforma"), accesible a través de la
        dirección web:{" "}
        <a href="https://ligavirtualf1.es" target="_blank">
          https://ligavirtualf1.es
        </a>
        .
      </p>

      <p>
        Al registrarte en nuestro sitio web, participar en nuestros campeonatos
        de simracing o utilizar cualquiera de nuestros servicios, aceptas
        cumplir y quedar sujeto a los siguientes Términos de Servicio. Si no
        estás de acuerdo con alguna parte de estos términos, por favor, no
        utilices nuestra plataforma ni participes en nuestras actividades.
      </p>

      <hr />

      <h3>1. NATURALEZA DEL SERVICIO</h3>
      <p>
        LigaVirtualF1 es una comunidad online sin ánimo de lucro dedicada a la
        organización, gestión y disfrute de campeonatos de simracing
        (automovilismo virtual). La plataforma ofrece un espacio de encuentro,
        registro de estadísticas y coordinación para entusiastas del motor
        virtual de forma completamente gratuita.
      </p>

      <h3>2. REGISTRO DE CUENTAS Y SEGURIDAD</h3>
      <p>
        Para participar activamente en la comunidad y en los campeonatos, es
        necesario crear una cuenta de usuario. Durante el registro, te
        solicitamos los siguientes datos:
      </p>
      <ul>
        <li>
          <strong>Datos obligatorios:</strong> Nombre, apellidos, nombre de
          usuario (Nick), correo electrónico, país (y comunidad autónoma si
          seleccionas España), contraseña y medio por el que nos conociste.
        </li>
        <li>
          <strong>Datos opcionales:</strong> Fecha de nacimiento y foto de
          perfil.
        </li>
      </ul>

      <p>Al registrarte, te comprometes a:</p>
      <ul>
        <li>Proporcionar información verídica y mantenerla actualizada.</li>
        <li>
          Ser responsable de la seguridad de tu contraseña. LigaVirtualF1 no se
          hace responsable de accesos no autorizados debido al descuido del
          usuario.
        </li>
        <li>
          No crear cuentas falsas ni suplantar la identidad de otros pilotos o
          usuarios.
        </li>
      </ul>

      <p className="note">
        <em>
          (Para más información sobre cómo protegemos y tratamos tus datos
          personales, consulta nuestra Política de Privacidad conforme al RGPD
          de España y la Unión Europea).
        </em>
      </p>

      <h3>3. NORMAS DE CONDUCTA Y USO COMPARTIDO</h3>
      <p>
        El pilar de LigaVirtualF1 es el juego limpio (<em>Fair Play</em>) y el
        respeto mutuo, tanto dentro como fuera de la pista. Queda estrictamente
        prohibido:
      </p>
      <ul>
        <li>
          El uso de insultos, discursos de odio, racismo, xenofobia o acoso a
          través de los foros, comentarios, perfiles o canales oficiales de la
          comunidad (incluyendo servidores de voz como Discord).
        </li>
        <li>
          El uso de software malicioso, herramientas de hackeo, ventajas
          competitivas no autorizadas (<em>cheats</em>) o cualquier método que
          altere el código de la web o el rendimiento justo en los simuladores.
        </li>
        <li>
          La publicación de contenido ofensivo, pornográfico o ilegal en las
          fotos de perfil o nombres de usuario.
        </li>
      </ul>
      <p>
        <strong>Sanciones:</strong> LigaVirtualF1 se reserva el derecho de
        suspender, banear o eliminar de forma temporal o permanente la cuenta de
        cualquier usuario y su participación en los campeonatos si se infringen
        estas normas, sin necesidad de preaviso.
      </p>

      <h3>4. PROPIEDAD INTELECTUAL</h3>
      <ul>
        <li>
          <strong>Contenido de la Comunidad:</strong> Los logos originales, el
          diseño web, los textos informativos y la estructura general de
          LigaVirtualF1 son propiedad exclusiva de la administración de la
          comunidad y no pueden ser reproducidos ni utilizados sin
          consentimiento previo.
        </li>
        <li>
          <strong>Librerías de Terceros:</strong> Esta web utiliza recursos de
          código abierto y librerías de terceros (como <em>Chart.js</em> para la
          visualización de gráficos). Los derechos de estas herramientas
          pertenecen a sus respectivos autores de acuerdo con sus propias
          licencias de software libre.
        </li>
        <li>
          <strong>Contenido de los Videojuegos y YouTube:</strong> Los vídeos de
          las carreras, retransmisiones en directo o imágenes subidas a
          plataformas como YouTube contienen propiedad intelectual propiedad de
          los desarrolladores de los propios simuladores y/o de la Formula One
          Administration (si aplica). LigaVirtualF1 hace uso de estos elementos
          con fines recreativos, informativos y de entretenimiento comunitario,
          respetando las políticas de uso compartido de los creadores de dichos
          juegos.
        </li>
      </ul>

      <h3>5. LIMITACIÓN DE RESPONSABILIDAD</h3>
      <p>
        Dado que LigaVirtualF1 es una plataforma de uso completamente gratuito y
        recreativo:
      </p>
      <ul>
        <li>
          El servicio se proporciona "tal cual" y "según disponibilidad". No
          garantizamos que la web esté operativa el 100% del tiempo. No nos
          hacemos responsables por pérdidas de datos de clasificaciones, caídas
          del servidor, interrupciones durante las sesiones de carrera o
          problemas técnicos ajenos a nuestro control.
        </li>
        <li>
          Al no existir ningún tipo de transacción comercial ni actividad
          lucrativa, la Comunidad se exime de cualquier responsabilidad por
          supuestos daños y perjuicios económicos o personales derivados del uso
          de la web o de la participación en las ligas virtuales.
        </li>
      </ul>

      <h3>6. MODIFICACIONES DE LOS TÉRMINOS</h3>
      <p>
        Nos reservamos el derecho de modificar estos Términos de Servicio en
        cualquier momento para adaptarlos a nuevas normativas legales, cambios
        técnicos en la web o nuevas dinámicas de los campeonatos. Avisaremos de
        los cambios importantes a través de la portada de la web o mediante un
        mensaje en nuestras las redes sociales. El uso continuo de la web tras
        la modificación implica la aceptación de los nuevos términos.
      </p>

      <h3>7. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h3>
      <p>
        Estos Términos de Servicio se rigen por la legislación española.
        Cualquier disputa o controversia relacionada con el uso de esta página
        web se someterá a los juzgados y tribunales competentes en España.
      </p>
    </>
  );
}
